<template>
  <div>
    <h2>Step 1: Manuscript Details</h2>

    <v-card max-width="720px" class="mt-5">
      <v-card-text>
        <v-form
          class="mr-2 mt-4"
          v-model="valid"
          @submit.prevent="submitManuscript"
        >
          <v-text-field
            outlined
            label="Manuscript title *"
            prepend-icon="mdi-format-title"
            :rules="rules.required"
            v-model="manuscript.title"
          ></v-text-field>

          <v-select
            outlined
            :rules="rules.required"
            :items="manuscriptTypes"
            label="Manuscript type *"
            prepend-icon="mdi-sticker-plus-outline"
            v-model="manuscript.type"
          ></v-select>

          <!-- <v-textarea
            autocomplete="email"
            outlined
            label="Abstract *"
            prepend-icon="mdi-sticker-text-outline"
            v-model="manuscript.abstract"
            hint="Maximum of 250 words"
            :rules="rules.requiredAbstract"
          ></v-textarea> -->

          <div class="ml-8">
            <label for="abstract">Abstract *</label>
            <vue-pell-editor
              :placeholder="editorPlaceholder"
              :actions="editorOptions"
              :style-with-css="false"
              :classes="editorClasses"
              default-paragraph-separator="p"
              v-model="abstractOutput"
              class="mb-2 mt-1"
              id="abstract"
            />
          </div>
          <!-- Todo: maybe fetch the keywords that have been used like positions in eVoting -->
          <!-- :items="items" -->
          <v-combobox
            chips
            outlined
            multiple
            label="Keywords *"
            :rules="rules.required"
            v-model="manuscript.keywords"
            prepend-icon="mdi-label-outline"
            hint="Type a keyword and hit enter. You may enter up to 5 keywords. "
          ></v-combobox>

          <v-checkbox
            class="mt-2 ml-8"
            color="green"
            v-model="forSpecialEdition"
            v-if="specialEditions.length > 0"
            label="I am submitting to a special edition"
          >
          </v-checkbox>

          <section v-if="forSpecialEdition">
            <v-select
              outlined
              :items="specialEditions"
              item-text="title"
              item-value="id"
              label="Special edition"
              prepend-icon="mdi-star-outline"
              v-model="manuscript.edition"
            ></v-select>
          </section>

          <div class="my-3 ml-8">
            <p>* mark required fields.</p>
            <v-btn
              large
              type="submit"
              color="green lighten-3"
              :disabled="!valid || !abstractOutput || loading"
              :loading="loading"
            >
              <v-icon left>mdi-content-save-check</v-icon>
              Save and Proceed
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
import dedent from "dedent";
import { editorOptions } from "../../tools/wysiwyg";
import { required, abstract } from "../../tools/rules";
import { manuscriptTypes } from "../../tools/manuscript";

export default {
  data: () => ({
    valid: false,
    showPassword: false,
    rules: {
      required,
      abstract,
      requiredAbstract: [...required, ...abstract],
    },

    manuscript: {
      title: null,
      type: "ORIGINAL RESEARCH",
      abstract: null,
      keywords: null,
      edition: null,
      authors: [],
      files: [],
    },

    loading: false,

    manuscriptTypes,

    forSpecialEdition: false,
    specialEditions: [],

    abstractOutput: null,

    editorOptions,
    editorPlaceholder: "Paste or type here..",
    editorClasses: {
      actionbar: "pell-actionbar",
      button: "pell-button",
      content: "pell-content",
      selected: "pell-button-selected",
    },
  }),

  methods: {
    submitManuscript() {
      this.loading = true;

      this.$axios
        .post("/manuscripts", {
          ...this.manuscript,
          ...{ abstract: this.cleanReviewText(this.abstractOutput) },
        })
        .then(({ data: response }) => {
          this.$bus.$emit("manuscript.refresh");

          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Manuscript saved",
          });

          this.$router.push({
            path: `/manuscripts/continue/${response._id}`,
          });
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not submit manuscript",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cleanReviewText(text) {
      return dedent(text.replace(/style="(.*?)" /g, ""));
    },
    fetchSpecialEditions() {
      this.$axios.get("/active-special-editions").then(({ data: response }) => {
        this.specialEditions = response;
      });
    },
  },

  mounted() {
    this.fetchSpecialEditions();
  },
};
</script>
